import { VERSION } from '../version';

export const environment = {
  api_url: 'https://vo-app.telcohub.sk/api/v1',
  stage: 'production',
  ssd_api_url: 'https://vo-app.telcohub.sk:18446/api/v1',
  zabbix_api_url: 'https://zabbix-ssd.kinet.sk:10481',
  version: VERSION,
};
